import React from 'react'

import BackButton from '@components/BackButton'
import { TabsPayments } from '@components/Tabs'
import useMain from '@hooks/useMain'
import useNetwork from '@hooks/useNetwork'
import useNetworkWallet from '@hooks/useNetworkWallet'
import { PaymentsHeader } from '@pages/PaymentsPage/styles'

import { PaymentSectionContainer, PaymentsMethodsList } from './styles'

interface IWalletLoginPage {
    title: string
}

let types: string[] = []
const optionsForLogin: string[] = ['Wallet', 'Email']

const WalletLoginPage: React.FC<IWalletLoginPage> = ({ title }) => {
    const {
        state: {
            currentStep,
            mainInit: { paymentMethods },
        },
        operations: {
            setWarningMessage,
            setShouldWarning,
            setCurrentStep,
            setMainInitPaymentMethods,
            validateWallets,
            reset: resetUseMain,
        },
    } = useMain()

    const {
        operations: { reset: resetUseNetwork },
    } = useNetwork()
    const {
        state: { walletProvider, isConnected },
        operations: { connectEthereumAlgorantWallet, handleWhiteList, reset: resetUseNetworkWallet },
    } = useNetworkWallet()

    const [active, setActive] = React.useState('')

    React.useMemo(() => {
        if (paymentMethods && paymentMethods.every(index => typeof index === 'string')) {
            const supportedWallets = validateWallets(paymentMethods as unknown as string[])
            setMainInitPaymentMethods(supportedWallets)
        }
    }, [paymentMethods])

    const handleVerifyPaymentMethod = () => {
        types = []
        const verifyPaymentMethodIsCreditCard = paymentMethods.find(method => method.type === 'creditcard')
        const verifyPaymentMethodIsCrypto = paymentMethods.find(method => method.type === 'crypto')
        if (verifyPaymentMethodIsCrypto && paymentMethods.includes(verifyPaymentMethodIsCrypto)) {
            types.push('Crypto')
        }
        if (verifyPaymentMethodIsCreditCard && paymentMethods.includes(verifyPaymentMethodIsCreditCard)) {
            types.push('Credit card')
        }
    }

    React.useEffect(() => {
        if (currentStep === 'login' && !types.includes('Wallet')) {
            types = []
            optionsForLogin.map(option => types.push(option))
        }
        if (currentStep === 'payments') handleVerifyPaymentMethod()
        setActive(types[0])
    }, [currentStep])

    React.useEffect(() => {
        connectEthereumAlgorantWallet()
    }, [connectEthereumAlgorantWallet, setShouldWarning, setWarningMessage, walletProvider])

    const checkWhiteList = React.useCallback(async () => {
        if (isConnected && walletProvider) {
            const isChecking = await handleWhiteList()
            const walletName = walletProvider?.getCurrentWallet()
            if (isChecking && walletName) {
                if (currentStep === 'login') setCurrentStep('inventory')
                if (currentStep === 'payments') setCurrentStep('payments-wallet')
            }
        }
    }, [handleWhiteList, isConnected, walletProvider])

    React.useEffect(() => {
        checkWhiteList()
    }, [checkWhiteList])

    const handleGoBack = React.useCallback(() => {
        resetUseMain()
        resetUseNetwork()
        resetUseNetworkWallet()
        setCurrentStep('home-multiple-sales-behaviour')
    }, [])

    return (
        <>
            {currentStep === 'payments' && (
                <PaymentsHeader as="header">
                    <BackButton handleClick={handleGoBack} message={'Back'} hasCaret />
                </PaymentsHeader>
            )}

            <PaymentSectionContainer>
                <h1>{title} </h1>
                <PaymentsMethodsList>
                    <TabsPayments types={types} active={active} setActive={setActive} />
                </PaymentsMethodsList>
            </PaymentSectionContainer>
        </>
    )
}

export default WalletLoginPage
